<div>
  <a class="show-ids clickable" (click)="showIds = !showIds"> {{ showIds ? 'Ukryj' : 'Pokaż' }} Id Mieszkańców</a>
  <div class="table">
    <div class="row header primary" [class.with-ids]="showIds">
      <div *ngIf="showIds">Id mieszkańca</div>
      <div>Imię i nazwisko</div>
      <div>Nieruchomość</div>
      <div>Jednostki</div>
      <div>Akcje</div>
    </div>
    <app-expandable-list [allData]="userResidents" [sliceLength]="10">
      <ng-template let-vm="data">
        <div class="row" [class.with-ids]="showIds">
          <div *ngIf="showIds">{{ vm.id }}</div>
          <div>{{ vm.name }}</div>
          <div>{{ vm.estateName }}</div>
          <div>{{ vm.unitNames || 'brak' }}</div>
          <div>
            <a *ngIf="canDelete && onDelete.observers.length" (click)="onDelete.emit(vm)">
              <mat-icon color="primary">delete</mat-icon>
            </a>
          </div>
        </div>
      </ng-template>
    </app-expandable-list>
  </div>
</div>
